import React from 'react';
import Logo from '../assets/Logo.png';
import {RiFacebookFill} from 'react-icons/ri';
import {AiOutlineLinkedin,AiOutlineInstagram} from 'react-icons/ai';



const Footer = () => {
  return (
    <div className='flex md:flex-row flex-col lg:justify-between w-screen lg:pt-12 p-6 pb-8 px-20 gap-4 relative bg-[#273773]'>
        <div className='flex flex-col'>
            <span className=''>sign up to our newsletter</span>
            <span className='flex'>
                <span className='w-[22rem] h-12 '><input type="text" placeholder='enter your email' className='w-full h-full border-[#273773] border-2 rounded px-2'/></span>
                <span className='px-6 py-3 text-base font-normal bg-[#273773] rounded text-white/90'>Subcribe</span>
            </span>
        </div>
        <div className='flex flex-col gap-3'>
            <span className=''><img src={Logo} alt='' className='w-40 h-14'></img></span>
            <div className='flex flex-col'>
                <span className='text-lg font-gilroyy font-normal text-[#000000]/50'>PROVIDING MARKETING </span>
                <span className='text-lg font-gilroyy font-normal text-[#000000]/50'>BUSINESS SUPPORT</span>
                <span className='text-lg font-gilroyy font-normal text-[#000000]/50'> SOLUTIONS SINCE 2018</span>
            </div>
            <div className='flex gap-3'>
                <a href='https://www.facebook.com/profile.php?id=61550311576022' rel='noreferrer' className='flex items-center p-1 text-[#000000]/60 bg-white rounded'><RiFacebookFill className='text-xl'/></a>
                <a href='https://www.linkedin.com/company/vydaagency/' rel='noreferrer' className='flex items-center p-1 text-[#000000]/60 bg-white rounded'><AiOutlineLinkedin className='text-xl'/></a>
                <a href='https://instagram.com/vydaagency?igshid=MzRlODBiNWFlZA==' rel='noreferrer' className='flex items-center p-1 text-[#000000]/60 bg-white rounded'><AiOutlineInstagram className='text-xl'/></a>
                
                
                
            </div>
        </div>
        <div className='flex bg-[#ffffff] py-4 px-6 rounded-md w-72'>
            <div className='flex flex-col gap-3'>
                <span className='flex flex-col gap-1'>
                    <span className='text-lg font-gilroyy font-light text-[#000000]/60'>Phone</span>
                    <span className='text-lg font-light text-[#000000]/90'>+234 (0) 818-733-7878</span>
                    <hr className='border text-[#000000]/60 w-full'></hr>
                </span>
                <span className='flex flex-col gap-1'>
                    <span className='text-lg font-gilroyy font-light text-[#000000]/60'>Adress</span>
                    <span className='text-lg font-light text-[#000000]/90'>Lagos, Nigeria</span>
                    <hr className='border text-[#000000]/60 w-full'></hr>
                </span>
                <span className='flex flex-col gap-1'>
                    <span className='text-lg font-gilroyy font-light text-[#000000]/60'>Email</span>
                    <span className='text-lg font-light text-[#000000]/90'>info@vydaagency.com</span>
                    <hr className='border text-[#000000]/60 w-full'></hr>
                </span>
            </div>
        </div>
    </div>
  )
}

export default Footer;